import Option from "../../../../Models/forms/Option";
import useStandards from "../../../../http/public/useStandards";
import Standard from "../../../../Models/common/Standard";

export default (): Option[] => {
  const standards: Standard[] = useStandards();

  return standards.map(({ id, name }) => ({ value: id, label: name }));
};
